module.exports = __webpack_public_path__ + "img/transgender-alt.fca28a99.svg";